<template>
  <div id="app" class="vue-tempalte">
    <b-navbar type="dark" variant="dark" class="titlebar">
      <b-navbar-brand class="title">VestOne NFT Generator</b-navbar-brand>
      <b-collapse id="nav-text-collapse" is-nav>
        <b-navbar-nav align="right" class="w-100">
          <label class="msg">{{ $t("NEWS") }}</label>
        </b-navbar-nav>
        <b-navbar-nav align="right" class="w-100">
          <!-- <b-button class="opensea-upload-button" v-show="isUploadVisible"
            >Openseaにアップロード</b-button
          > -->
          <Tutorial></Tutorial>
          <div style="width: 10%">&nbsp;&nbsp;</div>
          <!-- <b-button type="button" class="btn" @click="toggleAccount">
            <b-icon-gear></b-icon-gear>
            アカウント管理
          </b-button> -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view />
    <Account :openDialog="openAccountDialog" @closeDialog="closeAccount" />
  </div>
</template>


<script>
import Account from "@/components/Account";
import Tutorial from "@/components/Tutorial";

export default {
  name: "App",
  components: {
    Account,
    Tutorial,
  },
  data() {
    return {
      isUploadVisible: false,
      openAccountDialog: false,
    };
  },
  methods: {
    toggleAccount() {
      this.openAccountDialog = true;
    },
    closeAccount() {
      this.openAccountDialog = false;
    },
    scrollHandle(evt) {
      console.log(evt);
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #3e3e3e;
}
.titlebar {
  height: 70px;
  padding: 0 10px;
}
.title {
  width: 196px;
  height: 18px;
  text-align: center;
  font: normal normal normal 18px/24px Noto Sans CJK JP;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  margin-top: -20px;
  margin-left: 10px;
}
.nav-tabs {
  padding: 25px 10px 0;
}
.msg {
  color: yellow;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/App.vue